import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { ClienteAnaliseMercadoLancamentoModule } from '../../lancamento';
import { ClienteCentralCompraFormModule } from '../../../pessoa/cliente/central-compra/form';
import { ClienteCentralCompraParticipanteFormModule } from '../../../pessoa/cliente/central-compra/participante/form';
import { ClienteCarteiraPreBaixarModule } from '../../../cliente-carteira/prebaixar';
import { ClienteCarteiraBaixarModule } from '../../../cliente-carteira/baixar';
import { MetaIndicadorRealizadoPercProgressModule } from '../../../meta/components/indicador-realizado/perc-progress';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CdkScrollableModule, ScrollingModule } from '@angular/cdk/scrolling';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ClienteFormModalModule } from '../../../pessoa/cliente/form-modal';

import { ClienteAnaliseMercadoPerspectivaProjetadaComponent } from './cliente-analise-mercado-perspectiva-projetada.component';
import { ClienteAnaliseMercadoPerspectivaProjetadaListComponent } from './list';

@NgModule({
    imports: [
        SharedModule,
        ClienteAnaliseMercadoLancamentoModule,
        ClienteCentralCompraFormModule,
        ClienteCentralCompraParticipanteFormModule,
        ClienteCarteiraPreBaixarModule,
        ClienteCarteiraBaixarModule,
        MetaIndicadorRealizadoPercProgressModule,
        DragDropModule,
        CdkScrollableModule,
        ScrollingModule,
        InfiniteScrollModule,
        ClienteFormModalModule
    ],
    declarations: [
        ClienteAnaliseMercadoPerspectivaProjetadaComponent,
        ClienteAnaliseMercadoPerspectivaProjetadaListComponent
    ],
    exports: [
        ClienteAnaliseMercadoPerspectivaProjetadaComponent,
        ClienteAnaliseMercadoPerspectivaProjetadaListComponent
    ],
    providers: [ ]
})
export class ClienteAnaliseMercadoPerspectivaProjetadaModule { }
